require("./pplus_site_plainGallery.less")

import { VideoSettingsData } from "widgets/commonDataObjects/interfaces"
import { CSSTransitionGroup } from "react-transition-group"
import { SiteItemData } from "../../../../interfaces";
import { GalleryViewType } from "../../../../commonComponents/base/basicMediaCarousel";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { SiteMedia } from "../../../../siteWidgets/siteMedia";

interface PlainGalleryProps {
    medias: SiteItemData[]
    width: number
    videoSettings: VideoSettingsData
    intervalTime: number
    componentaColor: string
}

interface PlainGalleryState {
    selectedMediaIndex: number,
    num_of_scrolls_left_available: number
    num_of_scrolls_right_available: number
    width_in_pixels_of_last_overflowing_item_in_row: number
    rightOffset: number
    videoPlayStarted: boolean
}

export class PplusPlainGallery extends React.Component<PlainGalleryProps, PlainGalleryState>{
    constructor(props) {
        super(props as PlainGalleryProps);
        this.state = {
            selectedMediaIndex: 0,
            num_of_scrolls_left_available: null,
            num_of_scrolls_right_available: null,
            rightOffset: 0,
            width_in_pixels_of_last_overflowing_item_in_row: 0,
            videoPlayStarted: false
        }
    }

    componentWillMount() {
        const { medias, width } = this.props
        const galleryWidth = width - 46;
        if (medias.length > 0) {
            this.setupLisScrolling(medias, galleryWidth)
        }
    }
    private autoGalleryInterval: any;
    private startAutoGallery = () => {
        const { intervalTime, medias } = this.props
        const self = this;
        if (typeof (intervalTime) === "number") {
            if (intervalTime > 0) {
                this.autoGalleryInterval = setInterval(() => {
                    this.setState((prevState: PlainGalleryState, props: PlainGalleryProps) => {
                        let newIndex = ++prevState.selectedMediaIndex;
                        if (newIndex >= props.medias.length) newIndex = 0;
                        return { selectedMediaIndex: newIndex }
                    });
                }, intervalTime * 1000);
            }
            else {
                clearInterval(this.autoGalleryInterval)
            }
        }
    }
    componentDidMount() {
        if (this.props.medias.length > 1) {
            this.startAutoGallery();
        }
    }
    public static siteScriptName = "PplusPlainGallery";
    private single_List_item_width = 151

    private setupLisScrolling(medias: SiteItemData[], width: number) {
        const num_of_items = medias.length
        const single_media_item_width = this.single_List_item_width
        const num_of_medias_fit_in_full_row = Math.floor(width / single_media_item_width)
        const num_of_scrolls_left_available = Math.floor((num_of_items * single_media_item_width) / width)
        const num_of_scrolls_right_available = 0
        const width_in_pixels_of_last_overflowing_item_in_row = width - (single_media_item_width * num_of_medias_fit_in_full_row)
        this.setState({ num_of_scrolls_left_available, num_of_scrolls_right_available, width_in_pixels_of_last_overflowing_item_in_row })
    }

    private handleScrollLeftClicked = () => {
        const { width_in_pixels_of_last_overflowing_item_in_row, num_of_scrolls_left_available, num_of_scrolls_right_available, rightOffset } = this.state
        const { width, medias } = this.props
        const galleryWidth = width - 46;
        if (num_of_scrolls_left_available === 1) {
            const num_of_medias_fit_in_full_row = Math.floor(galleryWidth / this.single_List_item_width)
            const rightOffse = (this.single_List_item_width * (medias.length - num_of_medias_fit_in_full_row)) - width_in_pixels_of_last_overflowing_item_in_row
            this.setState({
                rightOffset: - rightOffse,
                num_of_scrolls_left_available: num_of_scrolls_left_available - 1 > 0 ? num_of_scrolls_left_available - 1 : 0,
                num_of_scrolls_right_available: num_of_scrolls_right_available + 1
            })
            return null
        }
        if (num_of_scrolls_left_available > 0) {
            this.setState({
                rightOffset: rightOffset - galleryWidth,
                num_of_scrolls_left_available: num_of_scrolls_left_available - 1 > 0 ? num_of_scrolls_left_available - 1 : 0,
                num_of_scrolls_right_available: num_of_scrolls_right_available + 1
            })
        }
    }

    private handleScrollRightClicked = () => {
        const { num_of_scrolls_right_available, num_of_scrolls_left_available, width_in_pixels_of_last_overflowing_item_in_row, rightOffset } = this.state
        const { width } = this.props
        const galleryWidth = width - 46;

        if (num_of_scrolls_right_available === 1) {
            this.setState({
                rightOffset: 0,
                num_of_scrolls_left_available: num_of_scrolls_left_available + 1,
                num_of_scrolls_right_available: num_of_scrolls_right_available - 1 > 0 ? num_of_scrolls_right_available - 1 : 0
            })
            return null
        }
        if (num_of_scrolls_right_available > 0) {
            this.setState({
                rightOffset: rightOffset + galleryWidth,
                num_of_scrolls_left_available: num_of_scrolls_left_available + 1,
                num_of_scrolls_right_available: num_of_scrolls_right_available - 1 > 0 ? num_of_scrolls_right_available - 1 : 0
            })
        }
    }
    private showPrevMedia = (medias) => {
        this.setState(state => state.selectedMediaIndex > 0 ? { selectedMediaIndex: state.selectedMediaIndex - 1 } : { selectedMediaIndex: medias.length - 1 })
        this.stopAutoGallery();
    }
    private showNextMedia = (medias) => {
        this.setState(state => state.selectedMediaIndex < medias.length - 1 ? { selectedMediaIndex: state.selectedMediaIndex + 1 } : { selectedMediaIndex: 0 })
        this.stopAutoGallery();
    }
    private stopAutoGallery = () => {
        if (this.props.intervalTime !== 0) {
            clearInterval(this.autoGalleryInterval)
        }

    }
    private onSelectMedia = (e, index: number) => {
        this.stopAutoGallery();
        const isVideo = this.props.medias[this.state.selectedMediaIndex].media.mediaType === "MEDIA_VIDEO"
        // const videoPlayStarted = this.state.selectedMediaIndex === index && isVideo
        this.setState({ selectedMediaIndex: index, videoPlayStarted: false })
    }

    private handleOnVideoPlayStarted = () => {
        this.setState({ videoPlayStarted: true })
    }
    private handleOnVideoPlayStopped = () => {
        this.setState({ videoPlayStarted: false })
    }

    componentWillReceiveProps(nextProps: PlainGalleryProps) {
        if (nextProps.medias.length > 0) {
            this.setupLisScrolling(nextProps.medias, nextProps.width)
        }
    }

    render() {
        const { medias, width, videoSettings, componentaColor } = this.props
        const { selectedMediaIndex, num_of_scrolls_right_available, num_of_scrolls_left_available, rightOffset, videoPlayStarted } = this.state
        const noTitleLink = !medias[selectedMediaIndex].titleLink
        const mediaHeight = Math.floor(width / 1.77)
        const galleryWidth = width - 46;
        if (medias.length === 0) { return null }
        const selectedDetailsStyle = { zIndex: 1 }
        const selectedMediaItem = medias[selectedMediaIndex]
        const buttonBg = { backgroundColor: componentaColor }
        return (
            <span>
                <div className="gallerySelectedMedia" >

                    {selectedMediaItem && (videoPlayStarted === false || null) &&
                        <div className="selectedMediaDetails" style={selectedDetailsStyle}>
                            {!noTitleLink ?
                                <HyperLinkBuilder
                                    href={selectedMediaItem.titleLink}
                                    linkTarget={selectedMediaItem.titleTargetLink}
                                    children={selectedMediaItem.title} >
                                    <div className="title"> <div dangerouslySetInnerHTML={{ __html: selectedMediaItem.title }} /> <span className="linkTo">{__("Full Story")}</span></div>
                                </HyperLinkBuilder> :
                                <div className="title" dangerouslySetInnerHTML={{ __html: selectedMediaItem.title }} />}
                        </div>}

                    <div className="galleryDroppedImage" style={{ height: mediaHeight }}>
                        <CSSTransitionGroup transitionName="media" transitionEnterTimeout={500} transitionLeave={false} >
                            <SiteMedia
                                onPlayStarted={() => this.handleOnVideoPlayStarted()}
                                onPlayStopped={() => this.handleOnVideoPlayStopped()}
                                data={selectedMediaItem.media} videoSettings={videoSettings} key={selectedMediaItem.media.url} width={width} height={mediaHeight} onSelect={this.stopAutoGallery} />
                        </ CSSTransitionGroup >

                    </div>
                </div>

                <div className="mediaListContainer">
                    <button className="scrollRightBtn galleryArrow"
                        disabled={num_of_scrolls_right_available === 0}
                        title="scroll right"
                        style={buttonBg}
                        aria-label="scroll right"
                        onClick={(e) => this.handleScrollRightClicked()} />
                    <button className="scrollLeftBtn galleryArrow"
                        disabled={num_of_scrolls_left_available === 0}
                        style={buttonBg}
                        title="scroll left"
                        aria-label="scroll left"
                        onClick={(e) => this.handleScrollLeftClicked()} />
                    <div className="mediaList" style={{ width: `${galleryWidth}px` }}>
                        <div className="mediaListWrapper" style={{ "marginRight": rightOffset }} >
                            {medias.map((item, index) =>
                                <div key={`galleryItem_${item.media.mediaId}`} onClick={(e) => this.onSelectMedia(e, index)} className="mediaWrapper">
                                    {item.media.mediaType === "MEDIA_VIDEO" && <span className="iconOnPoster small"></span>}
                                    {item.media.mediaType === "MEDIA_VIDEO" && <img className="lisPreviewImage" src={item.media.poster} />}
                                    {item.media.mediaType === "MEDIA_IMAGE" && <img className="lisPreviewImage" title={item.media.title} aria-hidden={item.media.ariaHidden} alt={item.media.alt} src={item.media.url} />}
                                    <div className="itemTitle" style={index === selectedMediaIndex ? { background: componentaColor } : { background: "#000" }}>{item.bottomText}</div>
                                </div>)}
                        </div>
                    </div>
                </div>
            </span>
        )
    }
}
